import { render, staticRenderFns } from "./PatientPaymentMethods.vue?vue&type=template&id=9c8bd9fc&scoped=true&"
import script from "./PatientPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PatientPaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./PatientPaymentMethods.vue?vue&type=style&index=0&id=9c8bd9fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8bd9fc",
  null
  
)

export default component.exports